var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{attrs:{"columns":_vm.columns,"data":_vm.globalReports.data,"total":_vm.globalReports.meta.total,"per-page":_vm.page.size,"current-page":_vm.page.number,"empty-message":"Laporan Stok Global Kosong"},on:{"pagechanged":_vm.handleChangePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }